import {
  Button,
  HStack,
  Box,
  Flex,
  IconButton,
  useDisclosure,
  Stack,
} from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';

const SISUFORGE = (process.env.REACT_APP_SISUFORGE_URL || 'https://sisuforge.com').replace(/\/$/, '');

const navButtonStyles = {
  fontSize: '3vmin',
  fontWeight: 'bold',
  width: '100%',
  py: 4,
  px: 6,
  borderRadius: 'lg',

  color: 'yellow',

  bg: 'whiteAlpha.400',
  backdropFilter: 'blur(10px)',
  _hover: {
    color: 'white',
    bg: 'blackAlpha.600',
    transform: 'scale(1.03)',
    textDecoration: 'underline',
    transition: 'all 0.2s ease-in-out',
  },
};

type NavItem =
  | { label: string; to: string; external?: false }
  | { label: string; href: string; external: true };

const links: NavItem[] = [
  { label: 'PROJECT CROHAM', to: '/about' },
  { label: 'CRONOS TRACKER', to: '/Tracker' },
  { label: 'HOLDER VOTING', to: '/vote' },
  { label: 'NFTs', to: '/nfts' },
  { label: 'Reckless Rampage Demo', to: '/rampage/demo' },
  { label: 'News', to: '/news' },
  { label: 'Crypto tax (FI)', href: `${SISUFORGE}/crypto-tax-fi`, external: true },
  { label: 'Travel Buddy', href: `${SISUFORGE}/travel-buddy`, external: true },
];

export const Navigation = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box>
      <Flex h={16} alignItems="center" justifyContent="space-between">
        <IconButton
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          size="md"
          aria-label="Toggle Menu"
          onClick={isOpen ? onClose : onOpen}
          bg="black"
          color="white"
          _hover={{
            bg: 'white',
            transform: 'scale(1.2)',
            color: 'black',
          }}
          transition="all 0.2s ease-in-out"
        />
      </Flex>

      {isOpen && (
        <Box
          mt={4}
          px={4}
          py={10}
          bg="rgba(0,0,0,0.6)"
          backdropFilter="blur(10px)"
          borderRadius="xl"
          boxShadow="lg"
        >
          <Stack spacing={3} align="center">
            {links.map((item, idx) => (
              <Box key={idx}>
                <Button
                  textShadow={'2px 0px 2px red'}
                  as={item.external ? 'a' : Link}
                  {...(item.external ? { href: item.href } : { to: item.to })}
                  onClick={onClose}
                  {...navButtonStyles}
                >
                  {item.label}
                </Button>
              </Box>
            ))}
          </Stack>
        </Box>
      )}
    </Box>
  );
};
